import { render, staticRenderFns } from "./OrderUpdatePaymentDiscounts.vue?vue&type=template&id=61916d1c"
import script from "./OrderUpdatePaymentDiscounts.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePaymentDiscounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports